import { useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '@greenkub-fronts/shared/interface';
import { getCurrentProject, setSignature, setSignatures } from '@greenkub-fronts/domain/signature';

import HtmlBodyLandingPage from '../../ui/web/html-body-landing-page/html-body-landing-page';
import { TemplateEnum } from '../../utils/enum';

const HtmlBodyLandingPageFeature = () => {
  const { documentSlug } = useParams<{ documentSlug: TemplateEnum }>();

  const dispatch = useDispatch<AppDispatch>();

  const project = useSelector((state: RootState) => getCurrentProject(state));

  const sign1Ref = useRef();
  const sign2Ref = useRef();

  useEffect(() => {
    if (!project) return;
    // Overwrite signature si Mandats de gestion
    if (documentSlug && documentSlug === TemplateEnum.MANDAT_GESTION) {
      dispatch(
        setSignature({
          signature: project?.mandatGestion
            ? project?.mandatGestion.lastName +
              ' ' +
              project?.mandatGestion.firstName
            : project?.customer.lastName + ' ' + project?.customer.firstName,
        })
      );
    }
    if (
      documentSlug &&
      [TemplateEnum.BDC, TemplateEnum.UPSELL].includes(documentSlug)
    ) {
      dispatch(setSignatures([false, false])); // 2 signatures à valider
    }
  }, [project, documentSlug]);

  return (
    <HtmlBodyLandingPage
      sign1Ref={sign1Ref}
      sign2Ref={sign2Ref}
      documentSlug={documentSlug}
    />
  );
};

export default HtmlBodyLandingPageFeature;
